export const SET_ROLES = 'Set roles'
export const DELETE_ROLE = 'Delete roles'
export const UPDATE_ROLE = 'Update roles'
